"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 17a2 2 0 1 1-4 0V7a2 2 0 1 1 4 0zM17 7v10a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0m-5 12a2 2 0 0 0 2-2v-7a2 2 0 1 0-4 0v7a2 2 0 0 0 2 2m0-10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1M6 19a2 2 0 0 1-2-2v-4a2 2 0 1 1 4 0v4a2 2 0 0 1-2 2m0-7a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1"
}), 'Conversion');
